import {
  ContentVariants,
  ReplacementConfig,
  ReplacementValues,
} from '../../config/replacementConfig'
import { processReplacement } from './processReplacement'
import { ReplaceInfo } from './substituteValue'

export enum TextPartTypes {
  text = 'TEXT',
  link = 'LINK',
}

export interface TextPart {
  type: TextPartTypes
  value: string
  to?: string
}

export const substituteLink = (
  baseString: string,
  replacementData: Record<string, ReplaceInfo>
) => {
  const reg = new RegExp('{(.*?)}', 'g')
  const replacedValues = baseString.match(reg)

  if (!replacedValues) {
    return baseString.split('').map((text) => ({
      type: TextPartTypes.text,
      value: text,
    }))
  }

  return baseString.split(reg).map(transformSubstring)

  function transformSubstring(subStr: string): TextPart {
    const check = Object.values(ReplacementValues).includes(
      subStr as ReplacementValues
    )
    if (!check) {
      return {
        type: TextPartTypes.text,
        value: subStr,
      }
    }

    switch (ReplacementConfig[subStr as ReplacementValues]) {
      case ContentVariants.link:
        return {
          type: TextPartTypes.link,
          value: String(processReplacement(subStr, {}, replacementData)),
          to: replacementData[subStr]?.to,
        }
      default:
        return {
          type: TextPartTypes.text,
          value: subStr,
        }
    }
  }
}
